import UpdateContactIdMappingRequestModelBase from '../_generated/modelBases/update-contact-id-mapping-request-model-base';

export default class UpdateContactIdMappingRequestModel extends UpdateContactIdMappingRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
